import jwt_decode from 'jwt-decode';
import axios from 'axios';

export const CODE_VERIFIER = 'CODE_VERIFIER';
export const USER_ID = 'USER_ID';

const dec2hex = (dec) => {
  return ('0' + dec.toString(16)).substr(-2);
};

export const generateCodeVerifier = () => {
  const array = new Uint32Array(96 / 2);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec2hex).join('');
};

const sha256 = (plain) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
};

const base64UrlEncode = (a) => {
  let str = '';
  const bytes = new Uint8Array(a);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
};

const generateCodeChallengeFromVerifier = async (v) =>  {
  const hashed = await sha256(v);
  return base64UrlEncode(hashed);
};

export const redirectToPF = (callbackLink, codeVerifier) => {
  generateCodeChallengeFromVerifier(codeVerifier).then((codeChallenge) => {
    window.location.assign(`${callbackLink}&code_challenge=${codeChallenge}`);
  });
};

export const fetchClGuid = (codeVerifier, REACT_REDIRECT, code, isRppCall = false) => {
  const redirect_uri = REACT_REDIRECT.startsWith('//') ? `https:${REACT_REDIRECT}` : REACT_REDIRECT;
  const url = process.env.AGENT_CENTRE_AUTH_URL;
  const bodyDetails = {
    'grant_type': 'authorization_code',
    'code': code,
    'code_verifier': codeVerifier,
    'client_id':process.env.AGENT_CENTRE_API_CLIENT_ID,
    'redirect_uri': redirect_uri,
  };
  const formBody = Object.keys(bodyDetails).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(bodyDetails[key])).join('&');
  const config = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  };
  return axios.post(url,formBody,config)
    .then((authResult) => {
      const decodedToken = jwt_decode(authResult.data.access_token);
      localStorage.setItem(USER_ID, decodedToken.sub);
      if( isRppCall ){
        const configRPP={
          headers: { Authorization: `Bearer ${authResult.data.access_token}` }
        };
        return axios.get(`${process.env.AGENT_CENTRE_API_BASE_URL}/agentcentre/rppdata`,configRPP);
      }
    });
};
